module.exports = __webpack_public_path__ + "static/media/corkease-logo.cfb07fc0.jpg";